import {Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {AuthService} from "../auth/auth.service";
import {I18NService} from "../utils/i18n.service";
import {Router} from "@angular/router";
import {StringUtils} from "../utils/string.utils";
import {Subscription} from 'rxjs';

@Component({
    selector: 'template-header',
    template: `
        <div class="toolbar PadH" [class.prepaid-active]="prepaidActive">

            <!-- tenant logo -->
            <a (click)="router.navigate(['/orders'])">
                <img height="50" alt="Logo" src="assets/images/logo_icon.svg" class="HideOnMobile"/>
            </a>


            <!-- top menu -->
            <p-menubar [model]="menuItems" class="header-menu"></p-menubar>


            <a *ngIf="prepaidActive" (click)="router.navigate(['/prepaid'])" class="header-prepaid-link MarR" title="{{v('menu_prepaid')}}">
                <i class="pi pi-plus-circle White"></i>
            </a>
            <a (click)="router.navigate(['/profile'])" class="header-profile-link MarR" title="Profil">
                <i class="pi pi-user White"></i>
            </a>

            <!-- language selector -->
            <i18n-selector></i18n-selector>


            <!-- custom-content -->
            <div class="header-custom-content d-col TexAlCenter">
                <ng-content></ng-content>
            </div>


            <!-- user selector -->
            <div (click)="op.toggle($event)" class="header-user-selector BsFsSmaller MarR"><span class="header-login-name">{{modelLogin}}</span> <i class="pi pi-users MarH"></i></div>
            <p-overlayPanel #op [dismissable]="true" class="WidAutoOnMobile">
                <ng-template pTemplate>
                    <skitbs-users></skitbs-users>
                </ng-template>
            </p-overlayPanel>
            <div (click)="onLogout()" class="BsFsSmaller MarR"><i class="pi pi-power-off White" title="Abmelden"></i></div>
        </div>
    `
})
export class TemplateHeaderComponent implements OnInit, OnDestroy {

    menuItems: MenuItem[] = [];
    headerTitle: string;
    headerTitleDetails: string;
    modelLogin: string;
    prepaidActive = false;
    private incomingMessagesSubscription: Subscription;

    @ViewChild('headerActionsTemplate')
    private headerActionsTemplate: TemplateRef<any>;

    /**
     * Constructor
     * @param authService
     */
    constructor(private authService: AuthService, public router: Router, public i18n : I18NService) {
    }

    /**
     * Lifecycle.
     */
    ngOnInit() {
        let pSession = this.authService.findCurrentSession();
        this.modelLogin = StringUtils.truncateEllipsis(pSession.tgFirstname + " " + pSession.tgLastname, 14);
        this.prepaidActive = pSession.prepaidActive;
        this.menuItems = [
            {label: this.v('menu_orders'), icon: 'pi pi-shopping-cart', routerLink: ['/orders']},
            {label: this.v('menu_history'), icon: 'pi pi-calendar', routerLink: ['/history']},
            {label: this.v('menu_menuplans'), icon: 'pi pi-book', routerLink: ['/menuplans']},
            {label: this.v('menu_invoices'), icon: 'pi pi-file-pdf', routerLink: ['/invoices']},
            {label: this.v('menu_messages'), icon: 'pi pi-envelope', routerLink: ['/messages']},
            {label: this.v('menu_prepaid'), icon: 'pi pi-plus-circle', routerLink: ['/prepaid'], visible : pSession.prepaidActive},
            {label: this.v('menu_profile'), icon: 'pi pi-user', routerLink: ['/profile']},
            {label: this.v('menu_terminate'), icon: 'pi pi-file-excel', routerLink: ['/contract-termination']},
            {label: this.v('logout'), icon: 'pi pi-sign-out', command: (evt) => this.onLogout(evt), styleClass: 'HideOnDesktop'}
        ]

        this.incomingMessagesSubscription = this.authService.incomingMessages$.subscribe(count => {
            this.menuItems[4].label = this.v('menu_messages') + (count > 0 ? " (" + count + ")" : "");
            this.menuItems = [...this.menuItems];
        });
    }

    ngOnDestroy(): void {
        if (this.incomingMessagesSubscription) {
            this.incomingMessagesSubscription.unsubscribe();
        }
    }

    /**
     * Gets I18N value.
     * @param aKey
     * @private
     */
    public v(aKey: string) {
        return this.i18n.v(aKey);
    }

    /**
     *
     */
    public onLogout(event? : any) : void {
        this.authService.logout();
        window.location.reload();
    }
}
